import { Button, colors, darken, Link, styled, Typography } from '@mui/material';
import { Field } from 'formik';

export const StyledLink = styled(Link)(() => ({
  textDecoration: 'none',
  color: '#145da0',
  fontSize: '14px',
  fontweight: '600',
  display: 'inline-block',
  padding: '0 6px',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const StyledForgotPasswordButton = styled(Button)(() => ({
  backgroundColor: colors.red[900],
  textTransform: 'capitalize',
  '&:hover': {
    backgroundColor: darken(colors.red[900], 0.125),
  },
}));

export const StyledSimpleText = styled(Typography)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textDecoration: 'none',
  fontSize: ' 14px',
  fontWeight: '600',
  marginTop: ' 8px',
  color: '#3C3445',
}));

export const StyledField = styled(Field)(() => ({
  margin: 'auto 0px 8px',
}));
